import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { StatusBadge } from "@/pages/AccountOrders";

export const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [expanded, setExpanded] = useState(null);

  const load = () => {
    api.get("/admin/orders", { params: status ? { status } : {} }).then((d) => setOrders(d.data)).catch(() => {});
  };
  useEffect(() => { load(); }, [status]);

  const update = async (orderId, field, value) => {
    setError("");
    try {
      await api.put(`/admin/orders/${orderId}`, { [field]: value });
      load();
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <div data-testid="admin-orders">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <h1 className="font-serif font-light text-cream text-3xl">Bestellingen</h1>
        <select data-testid="admin-order-status-filter" value={status} onChange={(e) => setStatus(e.target.value)} className="bg-ink border border-gold/15 px-4 py-2.5 text-xs text-cream">
          <option value="">Alle statussen</option>
          <option value="pending">In behandeling</option>
          <option value="paid">Betaald</option>
          <option value="shipped">Verzonden</option>
          <option value="delivered">Bezorgd</option>
          <option value="cancelled">Geannuleerd</option>
        </select>
      </div>
      {error && <p data-testid="admin-orders-error" className="text-xs text-red-400 mb-4">{error}</p>}

      <div className="space-y-4">
        {orders.map((o) => (
          <div key={o.order_id} data-testid={`admin-order-${o.order_id}`} className="border border-gold/15 bg-ink">
            <button onClick={() => setExpanded(expanded === o.order_id ? null : o.order_id)} className="w-full flex flex-wrap items-center justify-between gap-4 p-5 text-left">
              <div>
                <p className="font-mono text-xs text-gold">{o.order_id}</p>
                <p className="font-mono text-[10px] text-smoke mt-1">{o.name} · {o.email} · {new Date(o.created_at).toLocaleDateString("nl-NL")}</p>
              </div>
              <div className="flex items-center gap-4">
                <span className="font-serif text-lg text-cream">€ {o.total?.toFixed(2).replace(".", ",")}</span>
                <StatusBadge status={o.status} />
              </div>
            </button>
            {expanded === o.order_id && (
              <div className="border-t border-gold/10 p-5 grid md:grid-cols-2 gap-6">
                <div>
                  <p className="font-mono text-[9px] tracking-[0.25em] uppercase text-smoke mb-3">Artikelen</p>
                  {o.items.map((i) => (
                    <p key={i.slug} className="text-sm text-mist">{i.quantity} × {i.model} ({i.ml}) — € {(i.unit_price * i.quantity).toFixed(2).replace(".", ",")}</p>
                  ))}
                  <p className="font-mono text-[9px] tracking-[0.25em] uppercase text-smoke mt-5 mb-2">Adres</p>
                  <p className="text-sm text-mist">{o.address?.name}, {o.address?.street} {o.address?.house_number}, {o.address?.postal_code} {o.address?.city}, {o.address?.country}</p>
                  <p className="text-sm text-mist mt-2">Verzending: {o.shipping_method} ({o.shipping_cost === 0 ? "gratis" : `€ ${o.shipping_cost.toFixed(2).replace(".", ",")}`}){o.coupon_code ? ` · korting ${o.coupon_code}` : ""}</p>
                </div>
                <div className="space-y-4">
                  <label className="block">
                    <span className="font-mono text-[9px] tracking-[0.25em] uppercase text-smoke block mb-2">Status wijzigen</span>
                    <select
                      data-testid={`admin-order-status-${o.order_id}`}
                      value={o.status}
                      onChange={(e) => update(o.order_id, "status", e.target.value)}
                      className="w-full bg-obsidian border border-gold/15 px-4 py-2.5 text-sm text-cream"
                    >
                      {["pending", "paid", "shipped", "delivered", "cancelled"].map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </label>
                  <label className="block">
                    <span className="font-mono text-[9px] tracking-[0.25em] uppercase text-smoke block mb-2">Kargo / tracking nummer</span>
                    <input
                      data-testid={`admin-tracking-${o.order_id}`}
                      defaultValue={o.tracking_number || ""}
                      placeholder="bijv. 3SDEO123456789"
                      onBlur={(e) => e.target.value !== (o.tracking_number || "") && update(o.order_id, "tracking_number", e.target.value)}
                      className="w-full bg-obsidian border border-gold/15 px-4 py-2.5 text-sm text-cream focus:outline-none focus:border-gold/50"
                    />
                  </label>
                  <p className="font-mono text-[9px] text-smoke uppercase tracking-[0.15em]">Verzenden — status en tracking worden direct zichtbaar voor de klant</p>
                </div>
              </div>
            )}
          </div>
        ))}
        {orders.length === 0 && <p className="text-sm text-mist">Geen bestellingen gevonden.</p>}
      </div>
    </div>
  );
};

export default AdminOrders;
